export const videoCategories = [
  { id: 'primary', label: '小学', icon: 'ri-book-open-line' },
  { id: 'middle', label: '初中', icon: 'ri-graduation-cap-line' },
  { id: 'high', label: '高中', icon: 'ri-award-line' },
  { id: 'gaokao', label: '高考冲刺', icon: 'ri-fire-line' },
  { id: 'postgrad', label: '考研', icon: 'ri-medal-line' },
  { id: 'english', label: '英语/托福/雅思', icon: 'ri-global-line' },
  { id: 'cet', label: '英语四六级', icon: 'ri-translate-2' },
  { id: 'accounting', label: '会计考试', icon: 'ri-calculator-line' },
  { id: 'cpa', label: 'CPA注册会计师', icon: 'ri-bank-card-line' },
  { id: 'nurse', label: '护士执照考试', icon: 'ri-heart-pulse-line' },
  { id: 'doctor', label: '执业医师考试', icon: 'ri-stethoscope-line' },
  { id: 'law', label: '法律职业资格', icon: 'ri-scales-3-line' },
  { id: 'college', label: '大学课程', icon: 'ri-building-line' },
];

export const featuredVideos = [
  {
    id: '1',
    title: '高考数学压轴题全解析',
    teacher: '王建国老师',
    category: '高考冲刺',
    grade: '高三',
    price: 29.9,
    originalPrice: 59.9,
    duration: '45分钟',
    students: 12840,
    rating: 4.9,
    thumbnail: 'https://public.readdy.ai/ai/img_res/6925863eccb0f260e16c39a1e41e1d7f.jpg',
  },
  {
    id: '2',
    title: '考研英语阅读理解技巧精讲',
    teacher: '李晓梅老师',
    category: '考研',
    grade: '大学',
    price: 39.9,
    originalPrice: 79.9,
    duration: '60分钟',
    students: 8920,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20university%20teacher%20teaching%20English%20reading%20comprehension%2C%20modern%20classroom%2C%20books%20and%20notes%20on%20desk%2C%20bright%20educational%20environment&width=400&height=280&seq=v002&orientation=landscape',
  },
  {
    id: '3',
    title: '小学三年级语文古诗词讲解',
    teacher: '张慧老师',
    category: '小学',
    grade: '三年级',
    price: 9.9,
    originalPrice: 19.9,
    duration: '20分钟',
    students: 23100,
    rating: 5.0,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20primary%20school%20teacher%20teaching%20classical%20poetry%20to%20young%20students%2C%20colorful%20classroom%20with%20Chinese%20calligraphy%20decorations%2C%20cheerful%20atmosphere&width=400&height=280&seq=v003&orientation=landscape',
  },
  {
    id: '4',
    title: '初中物理力学基础全套课程',
    teacher: '陈明远老师',
    category: '初中',
    grade: '初二',
    price: 19.9,
    originalPrice: 39.9,
    duration: '35分钟',
    students: 15670,
    rating: 4.7,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20school%20physics%20teacher%20demonstrating%20mechanics%20experiment%2C%20laboratory%20setting%2C%20scientific%20equipment%2C%20educational%20and%20engaging%20environment&width=400&height=280&seq=v004&orientation=landscape',
  },
  {
    id: '5',
    title: '雅思写作7分攻略',
    teacher: '刘英老师',
    category: '英语/托福/雅思',
    grade: '大学',
    price: 49.9,
    originalPrice: 99.9,
    duration: '55分钟',
    students: 6340,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=English%20language%20teacher%20teaching%20IELTS%20writing%20skills%2C%20modern%20study%20room%20with%20English%20books%20and%20notes%2C%20professional%20educational%20setting&width=400&height=280&seq=v005&orientation=landscape',
  },
  {
    id: '6',
    title: '初级会计实务精讲班',
    teacher: '赵财务老师',
    category: '会计考试',
    grade: '职业',
    price: 59.9,
    originalPrice: 119.9,
    duration: '90分钟',
    students: 9870,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20accounting%20teacher%20explaining%20financial%20statements%20and%20bookkeeping%2C%20professional%20office%20setting%20with%20charts%20and%20spreadsheets%2C%20clean%20background&width=400&height=280&seq=v006&orientation=landscape',
  },
  {
    id: '7',
    title: '高考语文作文满分技巧',
    teacher: '孙文老师',
    category: '高考冲刺',
    grade: '高三',
    price: 24.9,
    originalPrice: 49.9,
    duration: '40分钟',
    students: 18920,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20language%20teacher%20teaching%20essay%20writing%20techniques%20for%20college%20entrance%20exam%2C%20classroom%20with%20writing%20samples%20on%20board%2C%20inspiring%20educational%20atmosphere&width=400&height=280&seq=v007&orientation=landscape',
  },
  {
    id: '8',
    title: '考研政治马原重点精讲',
    teacher: '周政老师',
    category: '考研',
    grade: '大学',
    price: 34.9,
    originalPrice: 69.9,
    duration: '50分钟',
    students: 7650,
    rating: 4.7,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20political%20science%20teacher%20explaining%20Marxist%20philosophy%20for%20graduate%20entrance%20exam%2C%20university%20lecture%20hall%2C%20serious%20academic%20atmosphere&width=400&height=280&seq=v008&orientation=landscape',
  },
  {
    id: '13',
    title: 'CPA会计·财务成本管理全套精讲',
    teacher: '林注会老师',
    category: 'CPA注册会计师',
    grade: '职业',
    price: 89.9,
    originalPrice: 179.9,
    duration: '120分钟',
    students: 11230,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20CPA%20accounting%20teacher%20explaining%20financial%20cost%20management%20with%20charts%20and%20spreadsheets%20on%20screen%2C%20modern%20training%20classroom%2C%20business%20professional%20setting&width=400&height=280&seq=v013&orientation=landscape',
  },
  {
    id: '14',
    title: 'CPA审计·税法核心考点突破',
    teacher: '吴审计老师',
    category: 'CPA注册会计师',
    grade: '职业',
    price: 79.9,
    originalPrice: 159.9,
    duration: '95分钟',
    students: 8760,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20certified%20public%20accountant%20teacher%20teaching%20audit%20and%20tax%20law%2C%20professional%20office%20environment%20with%20financial%20documents%20and%20laptop%2C%20serious%20academic%20atmosphere&width=400&height=280&seq=v014&orientation=landscape',
  },
  {
    id: '15',
    title: '护士执照·基础护理学精讲',
    teacher: '王护士长老师',
    category: '护士执照考试',
    grade: '职业',
    price: 59.9,
    originalPrice: 119.9,
    duration: '80分钟',
    students: 19870,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20nursing%20teacher%20explaining%20basic%20nursing%20care%20procedures%20in%20medical%20training%20classroom%2C%20nursing%20uniform%2C%20medical%20equipment%20and%20models%20on%20table%2C%20professional%20healthcare%20education%20setting&width=400&height=280&seq=v015&orientation=landscape',
  },
  {
    id: '16',
    title: '护士执照·内外科护理高频考点',
    teacher: '陈护理老师',
    category: '护士执照考试',
    grade: '职业',
    price: 49.9,
    originalPrice: 99.9,
    duration: '70分钟',
    students: 15430,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20nurse%20educator%20teaching%20internal%20and%20surgical%20nursing%20exam%20key%20points%2C%20hospital%20training%20room%20with%20anatomy%20charts%20and%20medical%20posters%2C%20professional%20nursing%20education&width=400&height=280&seq=v016&orientation=landscape',
  },
  {
    id: '17',
    title: '英语四级·听力阅读写作全攻略',
    teacher: '张四级老师',
    category: '英语四六级',
    grade: '大学',
    price: 29.9,
    originalPrice: 59.9,
    duration: '65分钟',
    students: 38920,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20English%20teacher%20teaching%20CET-4%20exam%20strategies%20for%20listening%20reading%20and%20writing%2C%20university%20classroom%20with%20English%20study%20materials%2C%20energetic%20teaching%20atmosphere&width=400&height=280&seq=v017&orientation=landscape',
  },
  {
    id: '18',
    title: '英语六级·翻译写作冲刺班',
    teacher: '刘六级老师',
    category: '英语四六级',
    grade: '大学',
    price: 39.9,
    originalPrice: 79.9,
    duration: '75分钟',
    students: 24560,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20English%20teacher%20teaching%20CET-6%20translation%20and%20writing%20skills%2C%20modern%20university%20lecture%20room%20with%20English%20grammar%20notes%20on%20whiteboard%2C%20focused%20academic%20environment&width=400&height=280&seq=v018&orientation=landscape',
  },
  {
    id: '19',
    title: '执业医师·临床医学综合笔试精讲',
    teacher: '赵主任医师老师',
    category: '执业医师考试',
    grade: '职业',
    price: 99.9,
    originalPrice: 199.9,
    duration: '110分钟',
    students: 13450,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20licensed%20doctor%20teacher%20explaining%20clinical%20medicine%20exam%20content%2C%20medical%20school%20classroom%20with%20anatomy%20models%20and%20medical%20charts%2C%20professional%20physician%20education%20setting&width=400&height=280&seq=v019&orientation=landscape',
  },
  {
    id: '20',
    title: '执业医师·中医综合考点全解',
    teacher: '孙中医老师',
    category: '执业医师考试',
    grade: '职业',
    price: 89.9,
    originalPrice: 179.9,
    duration: '100分钟',
    students: 9870,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20medicine%20doctor%20teacher%20explaining%20TCM%20exam%20key%20points%2C%20classroom%20with%20Chinese%20herbal%20medicine%20charts%20and%20acupuncture%20models%2C%20warm%20traditional%20medical%20education%20atmosphere&width=400&height=280&seq=v020&orientation=landscape',
  },
  {
    id: '21',
    title: '法律职业资格·民法刑法核心考点',
    teacher: '郑律师老师',
    category: '法律职业资格',
    grade: '职业',
    price: 79.9,
    originalPrice: 159.9,
    duration: '90分钟',
    students: 16780,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20lawyer%20teacher%20explaining%20civil%20law%20and%20criminal%20law%20for%20bar%20exam%2C%20law%20school%20classroom%20with%20legal%20books%20and%20scales%20of%20justice%2C%20serious%20professional%20legal%20education%20setting&width=400&height=280&seq=v021&orientation=landscape',
  },
  {
    id: '22',
    title: '法律职业资格·行政法诉讼法精讲',
    teacher: '何法学老师',
    category: '法律职业资格',
    grade: '职业',
    price: 69.9,
    originalPrice: 139.9,
    duration: '85分钟',
    students: 11230,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20law%20professor%20teaching%20administrative%20law%20and%20procedural%20law%20for%20legal%20qualification%20exam%2C%20university%20law%20school%20lecture%20hall%20with%20legal%20reference%20books%2C%20authoritative%20academic%20atmosphere&width=400&height=280&seq=v022&orientation=landscape',
  },
  {
    id: '23',
    title: '高考数学·函数与导数专题突破',
    teacher: '吴数学老师',
    category: '高考冲刺',
    grade: '高三',
    price: 26.9,
    originalPrice: 52.9,
    duration: '48分钟',
    students: 21340,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20high%20school%20math%20teacher%20writing%20function%20and%20derivative%20formulas%20on%20whiteboard%2C%20bright%20classroom%20with%20math%20textbooks%20and%20exam%20papers%20on%20desk%2C%20focused%20academic%20atmosphere%2C%20warm%20educational%20lighting&width=400&height=280&seq=v023&orientation=landscape',
  },
  {
    id: '24',
    title: '高考化学·有机化学反应全解析',
    teacher: '林化学老师',
    category: '高考冲刺',
    grade: '高三',
    price: 22.9,
    originalPrice: 45.9,
    duration: '42分钟',
    students: 16780,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20high%20school%20chemistry%20teacher%20explaining%20organic%20chemistry%20reactions%20with%20molecular%20models%20and%20periodic%20table%20on%20wall%2C%20clean%20laboratory%20classroom%2C%20professional%20educational%20setting%20with%20warm%20tones&width=400&height=280&seq=v024&orientation=landscape',
  },
  {
    id: '25',
    title: '高考物理·力学电磁学综合冲刺',
    teacher: '郑物理老师',
    category: '高考冲刺',
    grade: '高三',
    price: 28.9,
    originalPrice: 57.9,
    duration: '52分钟',
    students: 14560,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20high%20school%20physics%20teacher%20demonstrating%20electromagnetic%20experiment%20with%20equipment%20on%20desk%2C%20modern%20science%20classroom%20with%20physics%20diagrams%20on%20whiteboard%2C%20inspiring%20educational%20environment&width=400&height=280&seq=v025&orientation=landscape',
  },
  {
    id: '26',
    title: '高考英语·阅读理解与完形填空技巧',
    teacher: '何英语老师',
    category: '高考冲刺',
    grade: '高三',
    price: 19.9,
    originalPrice: 39.9,
    duration: '38分钟',
    students: 29870,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20English%20teacher%20teaching%20reading%20comprehension%20and%20cloze%20test%20skills%20for%20college%20entrance%20exam%2C%20classroom%20with%20English%20vocabulary%20charts%20and%20exam%20papers%2C%20energetic%20and%20focused%20teaching%20atmosphere&width=400&height=280&seq=v026&orientation=landscape',
  },
  {
    id: '27',
    title: '高考历史·近现代史重点考点精讲',
    teacher: '赵历史老师',
    category: '高考冲刺',
    grade: '高三',
    price: 18.9,
    originalPrice: 37.9,
    duration: '44分钟',
    students: 11230,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20history%20teacher%20explaining%20modern%20Chinese%20history%20key%20exam%20points%20with%20historical%20maps%20and%20timeline%20on%20whiteboard%2C%20classroom%20with%20history%20books%20and%20cultural%20artifacts%2C%20serious%20academic%20atmosphere&width=400&height=280&seq=v027&orientation=landscape',
  },
  {
    id: '28',
    title: '考研数学·高等数学极限微积分精讲',
    teacher: '钱数学老师',
    category: '考研',
    grade: '大学',
    price: 44.9,
    originalPrice: 89.9,
    duration: '72分钟',
    students: 18430,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20graduate%20exam%20math%20teacher%20explaining%20calculus%20and%20limits%20on%20large%20whiteboard%2C%20university%20study%20room%20with%20advanced%20mathematics%20textbooks%20and%20notes%2C%20serious%20focused%20academic%20environment&width=400&height=280&seq=v028&orientation=landscape',
  },
  {
    id: '29',
    title: '考研英语·长难句翻译与写作提分',
    teacher: '孙英语老师',
    category: '考研',
    grade: '大学',
    price: 38.9,
    originalPrice: 77.9,
    duration: '65分钟',
    students: 13670,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20English%20teacher%20teaching%20complex%20sentence%20translation%20and%20essay%20writing%20for%20graduate%20entrance%20exam%2C%20modern%20study%20room%20with%20English%20grammar%20books%20and%20writing%20samples%20on%20desk%2C%20professional%20academic%20setting&width=400&height=280&seq=v029&orientation=landscape',
  },
  {
    id: '30',
    title: '考研专业课·经济学微观宏观全套',
    teacher: '周经济老师',
    category: '考研',
    grade: '大学',
    price: 52.9,
    originalPrice: 105.9,
    duration: '88分钟',
    students: 9870,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20economics%20professor%20teaching%20microeconomics%20and%20macroeconomics%20for%20graduate%20exam%2C%20university%20lecture%20hall%20with%20economic%20charts%20and%20supply%20demand%20graphs%20on%20screen%2C%20authoritative%20academic%20atmosphere&width=400&height=280&seq=v030&orientation=landscape',
  },
  {
    id: '31',
    title: '考研政治·近代史纲要与思修精讲',
    teacher: '吴政治老师',
    category: '考研',
    grade: '大学',
    price: 32.9,
    originalPrice: 65.9,
    duration: '58分钟',
    students: 22340,
    rating: 4.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20political%20theory%20teacher%20explaining%20modern%20Chinese%20history%20and%20ethics%20for%20graduate%20entrance%20exam%2C%20university%20classroom%20with%20political%20theory%20books%20and%20historical%20timeline%2C%20serious%20academic%20environment&width=400&height=280&seq=v031&orientation=landscape',
  },
  {
    id: '32',
    title: '考研数学·线性代数与概率论冲刺',
    teacher: '陈数学老师',
    category: '考研',
    grade: '大学',
    price: 42.9,
    originalPrice: 85.9,
    duration: '80分钟',
    students: 15890,
    rating: 4.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20graduate%20math%20teacher%20explaining%20linear%20algebra%20and%20probability%20theory%20with%20matrix%20formulas%20on%20whiteboard%2C%20university%20study%20room%20with%20advanced%20math%20textbooks%20and%20practice%20papers%2C%20focused%20academic%20atmosphere&width=400&height=280&seq=v032&orientation=landscape',
  },
];
